import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
    data: {}
}

export const initSlice = createSlice({
    name: 'init',
    initialState,
    reducers: {
        setInit: (state, action) => {
            state.data = { ...state.data, ...action.payload }
        },
        setFloor: (state, action) => {
            state.data.floor = action.payload
        },
        setRoom: (state, action) => {
            state.data.room = action.payload
        },
        setBuilding: (state, action) => {
            state.data.building = action.payload
        },
    },
})

export const { setInit, setBuilding, setFloor, setRoom } = initSlice.actions

export default initSlice.reducer
